import { FileType } from '@office-start/document-types';
export var appsNotSupporting0ByteFile = [
    FileType.Excel,
    FileType.Visio,
];
export var appsRequireLicense = [FileType.Visio];
//# sourceMappingURL=constants.js.map